webpackJsonp([7356694376651505000],{

/***/ "./src/components/Layout/TableOfContents.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n\n  & > ul, .chapterItems {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  p, h6 {\n    display: inline-block;\n    font-weight: 200;\n    margin: 0;\n  }\n  \n  .tocHeading {\n     font-weight: 200;\n     color: ', ';\n     margin-bottom: 10px;\n  }\n'], ['\n  padding: ', ';\n\n  & > ul, .chapterItems {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  p, h6 {\n    display: inline-block;\n    font-weight: 200;\n    margin: 0;\n  }\n  \n  .tocHeading {\n     font-weight: 200;\n     color: ', ';\n     margin-bottom: 10px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  h6, p {\n    color: black;\n    margin: 0;\n    line-height: 1.5;\n  }\n  li {\n    margin: 0;\n  }\n  &:hover {\n    li {\n      span {\n        border-bottom: 1px solid black;\n      }\n    }\n  }\n'], ['\n  h6, p {\n    color: black;\n    margin: 0;\n    line-height: 1.5;\n  }\n  li {\n    margin: 0;\n  }\n  &:hover {\n    li {\n      span {\n        border-bottom: 1px solid black;\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This class should not be used for listing posts, but for chapter based Docs. See PostListing for that.
	// You'll also need to add your chapters to siteConfig
	
	var TableOfContents = function (_React$Component) {
	  _inherits(TableOfContents, _React$Component);
	
	  function TableOfContents() {
	    _classCallCheck(this, TableOfContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TableOfContents.prototype.buildNodes = function buildNodes() {
	    var posts = this.props.posts;
	
	    var type = this.props.contentsType;
	    var postNodes = [];
	    posts.forEach(function (post) {
	      if (post.node.frontmatter.type === type) {
	        var postNode = {
	          title: post.node.frontmatter.title,
	          path: post.node.fields.slug,
	          lessonNumber: post.node.frontmatter.lesson,
	          chapter: post.node.frontmatter.chapter
	        };
	        postNodes.push(postNode);
	      }
	    });
	
	    var postNodeChapters = [];
	    postNodes.forEach(function (post) {
	      if (postNodeChapters[post.chapter]) {
	        postNodeChapters[post.chapter].push(post);
	      } else {
	        postNodeChapters[post.chapter] = [post];
	      }
	    });
	
	    postNodeChapters.forEach(function (chapter) {
	      chapter.sort(function (a, b) {
	        return a.lessonNumber > b.lessonNumber;
	      });
	    });
	    return postNodeChapters;
	  };
	
	  TableOfContents.prototype.nodeListItems = function nodeListItems() {
	    var postNodeChapters = this.buildNodes();
	    var listItems = [];
	    var chapterTitles = this.props.chapterTitles;
	    postNodeChapters.forEach(function (chapter, idx) {
	      var chapterLessons = [];
	      chapter.forEach(function (node) {
	        chapterLessons.push(_react2.default.createElement(
	          LessonContainer,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: node.path },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  node.chapter,
	                  '.',
	                  node.lessonNumber,
	                  ' \xA0'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  node.title
	                )
	              )
	            )
	          )
	        ));
	      });
	      listItems.push(_react2.default.createElement(
	        'li',
	        { className: 'chapter' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'tocHeading' },
	          chapterTitles[idx].toUpperCase()
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'chapterItems' },
	          chapterLessons
	        )
	      ));
	    });
	    return listItems;
	  };
	
	  TableOfContents.prototype.render = function render() {
	    return _react2.default.createElement(
	      TableOfContentsContainer,
	      null,
	      _react2.default.createElement(
	        'ul',
	        null,
	        this.nodeListItems()
	      )
	    );
	  };
	
	  return TableOfContents;
	}(_react2.default.Component);
	
	var TableOfContentsContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.brand;
	});
	
	var LessonContainer = _styledComponents2.default.div(_templateObject2);
	
	exports.default = TableOfContents;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-lodash/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/lesson.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  height: 100vh;\n  display: grid;\n  grid-template-rows: 75px 1fr;\n  grid-template-columns: 300px 1fr;\n  \n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    height: inherit;\n  }\n"], ["\n  height: 100vh;\n  display: grid;\n  grid-template-rows: 75px 1fr;\n  grid-template-columns: 300px 1fr;\n  \n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    height: inherit;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ", ";\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n  \n  & > div {\n    max-width: ", ";\n    margin: auto;\n  }\n  \n  & > h1 {\n    color: ", ";\n  }\n"], ["\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n  overflow: scroll;\n  justify-self: center;\n  width: 100%;\n  padding: ", ";\n  @media screen and (max-width: 600px) {\n    order: 2;\n  }\n  \n  & > div {\n    max-width: ", ";\n    margin: auto;\n  }\n  \n  & > h1 {\n    color: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  grid-column: 1 / 3;\n  grid-row: 1 / 2;\n  z-index: 2;\n   @media screen and (max-width: 600px) {\n    order: 1;\n  }\n"], ["\n  grid-column: 1 / 3;\n  grid-row: 1 / 2;\n  z-index: 2;\n   @media screen and (max-width: 600px) {\n    order: 1;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  grid-column: 1 / 2;\n  grid-row: 2 / 3;\n  background: ", ";\n  overflow: scroll;\n   @media screen and (max-width: 600px) {\n    order: 3;\n    overflow: inherit;\n  }\n"], ["\n  grid-column: 1 / 2;\n  grid-row: 2 / 3;\n  background: ", ";\n  overflow: scroll;\n   @media screen and (max-width: 600px) {\n    order: 3;\n    overflow: inherit;\n  }\n"]);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SEO = __webpack_require__("./src/components/SEO/SEO.jsx");
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Header = __webpack_require__("./src/components/Layout/Header.jsx");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SiteConfig = __webpack_require__("./data/SiteConfig.js");
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _TableOfContents = __webpack_require__("./src/components/Layout/TableOfContents.jsx");
	
	var _TableOfContents2 = _interopRequireDefault(_TableOfContents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LessonTemplate = function (_React$Component) {
	  _inherits(LessonTemplate, _React$Component);
	
	  function LessonTemplate() {
	    _classCallCheck(this, LessonTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LessonTemplate.prototype.render = function render() {
	    var slug = this.props.pathContext.slug;
	
	    var postNode = this.props.data.postBySlug;
	    var post = postNode.frontmatter;
	    if (!post.id) {
	      post.id = slug;
	    }
	    if (!post.id) {
	      post.category_id = _SiteConfig2.default.postDefaultCategoryID;
	    }
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          post.title + " | " + _SiteConfig2.default.siteTitle
	        )
	      ),
	      _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	      _react2.default.createElement(
	        BodyGrid,
	        null,
	        _react2.default.createElement(
	          HeaderContainer,
	          null,
	          _react2.default.createElement(_Header2.default, { location: this.props.location })
	        ),
	        _react2.default.createElement(
	          ToCContainer,
	          null,
	          _react2.default.createElement(_TableOfContents2.default, {
	            posts: this.props.data.allPostTitles.edges,
	            contentsType: "lesson",
	            chapterTitles: _SiteConfig2.default.toCChapters
	          })
	        ),
	        _react2.default.createElement(
	          BodyContainer,
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h1",
	              null,
	              post.title
	            ),
	            _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: postNode.html } })
	          )
	        )
	      )
	    );
	  };
	
	  return LessonTemplate;
	}(_react2.default.Component);
	
	exports.default = LessonTemplate;
	
	
	var BodyGrid = _styledComponents2.default.div(_templateObject);
	
	var BodyContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	}, function (props) {
	  return props.theme.accentDark;
	});
	
	var HeaderContainer = _styledComponents2.default.div(_templateObject3);
	
	var ToCContainer = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.theme.lightGrey;
	});
	
	/* eslint no-undef: "off"*/
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-lesson-jsx-fe09319423afc82f4898.js